export default __webpack_public_path__ + "static/media/screen_32.61b6a3b7.png";